/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgradenow1Inputs */

const en_upgradenow1 = /** @type {(inputs: Upgradenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upgrade now`)
};

const de_upgradenow1 = /** @type {(inputs: Upgradenow1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jetzt wechseln`)
};

/**
* | output |
* | --- |
* | "Upgrade now" |
*
* @param {Upgradenow1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const upgradenow1 = /** @type {((inputs?: Upgradenow1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgradenow1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgradenow1(inputs)
	return de_upgradenow1(inputs)
});
export { upgradenow1 as "upgradeNow" }